import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router';
import DefaultLogo from '../../components/Logo/DefaultLogo.png';
import { selectConfig, selectActivePrivacyStatementUrl, selectActiveTermsOfUseUrl } from '../../redux/config/selectors';
import { windowMaxWidth } from '../../components/ui/Layout/breakpoints';
import SimpleLayoutStyleWrapper from './SimpleLayout.style';
import background from './oqio-background-3.jpg';

const Background = styled.img`
  height: 100vh;

  @supports (height: 100lvh;) {
    height: 100lvh;
  }

  inset: 0;
  object-fit: cover;
  position: fixed;
  width: 100%;
  z-index: 1;
`;

const LogoWrapper = styled(Link)`
  align-items: center;
  display: flex;
  left: 30px;
  max-width: 40vw;
  min-height: 60px;
  position: absolute;
  z-index: 5;

  &:focus,
  &:active {
    border: none;
    outline: 0;
  }

  @media ${windowMaxWidth.mobile} {
    padding: 0 30px;
    max-width: 100%;
    width: 100%;
    left: 0;
  }
`;

const LogoIcon = styled.img`
  margin-right: 10px;
  max-height: 40px;
  max-width: 40px;
`;

const LogoTitle = styled.div`
  color: var(--greyscale-white);
  display: block;
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-medium);
`;

const SimpleLayout = ({ config, activePrivacyStatementUrl, activeTermsOfUseUrl, component: Component, ...props }) => {
  useEffect(() => {
    handleTabIcon();
  }, [config]);

  const agencyLogo = config?.tenant_logo?.url_small || config?.tenant_logo?.url;
  const agencyName = config?.tenant_name;
  const imprintUrl = config?.imprint?.url;

  const handleTabIcon = () => {
    if (agencyLogo) {
      let link = document.querySelector('link[rel~="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = agencyLogo || DefaultLogo;
    }
  };

  return (
    <SimpleLayoutStyleWrapper>
      <LogoWrapper to="/">
        <LogoIcon src={agencyLogo || DefaultLogo} alt="Agency Logo" />
        <LogoTitle>{agencyName || 'Ihr Versicherungsportal'}</LogoTitle>
      </LogoWrapper>
      <Component {...props} />
      <div className="terms-menu">
        {imprintUrl ? (
          <a className={'oqio-link valid-link'} href={imprintUrl} target={'_blank'} rel="noopener noreferrer">
            Impressum
          </a>
        ) : (
          <span className={'oqio-link'}>Impressum</span>
        )}
        <a className={'oqio-link valid-link'} href={activeTermsOfUseUrl} target={'_blank'} rel="noopener noreferrer">
          Nutzungsbedingungen
        </a>
        <a
          className={'oqio-link valid-link'}
          href={activePrivacyStatementUrl}
          target={'_blank'}
          rel="noopener noreferrer"
        >
          Datenschutzerklärung
        </a>
      </div>
      <Background src={background} alt="risk" />
    </SimpleLayoutStyleWrapper>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfig(state),
  activePrivacyStatementUrl: selectActivePrivacyStatementUrl(state),
  activeTermsOfUseUrl: selectActiveTermsOfUseUrl(state)
});

export default connect(mapStateToProps, {})(SimpleLayout);
